module.exports = __webpack_public_path__ + "img/booths_mobile_homepage.cfc47001.svg";